import React, { useState } from "react"
import classNames from "classnames"
import styled, { css } from "styled-components"
import { media } from "utils/Media"
import { GatsbyImage } from "gatsby-plugin-image"
import ContainerMax from "components/shared/ContainerMax"
import { Row, Col } from "reactstrap"
import Slider from "react-slick"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faChevronLeft, faChevronRight} from "@fortawesome/pro-light-svg-icons"

const Wrap = styled.div`
  padding-top: 15px;
  h3 {
    z-index: 10;
    position: relative;
    color: white;
    font-size: 50px;

    @media ${media.md} {
      font-size: 90px;
    }
  }
`

const BgImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  .gatsby-image-wrapper {
    height: 100%;
  }
`

const Nav = styled.div`
  margin-bottom: 2rem;
  position: relative;
  z-index: 2;
  padding: 0 30px;

  .slide {
    padding: 0 .5rem;
    width: 75px;
  }

  .next, .prev {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -30px;
    z-index: 10;
    background: transparent;
    color: white;
    border: 0;

  }

  .next {
    left: auto;
    right: -30px;
  }
`

const YearBtn = styled.button`
  background: white;
  padding: .2rem 1rem;
  border: 0;
  font-family: ${props => props.theme.font.family.bold};
  color: ${props => props.theme.colors.primary};
  width: 100%;

  ${props => props.active && css`
    background: ${props => props.theme.colors.secondary};
    color: white;
  `}
`

const Player = styled.div`
  width: 50%;
  padding: 0 15px 15px 15px;
  position: relative;
  z-index: 2;

  @media ${media.sm} {
    width: 33%;
  }

  @media ${media.md} {
    width: 25%;
  }

  @media ${media.lg} {
    width: 20%;
  }

  .content {
    background: white;
    height: 100%;
    text-align: center;
    font-family: ${props => props.theme.font.family.bold};
    
    .player {
      margin: .5rem 0 .25rem 0;
      font-family: ${props => props.theme.font.family.atp};
    }
    .year {
      margin: 0 0 .5rem 0;
      font-family: ${props => props.theme.font.family.atp};
      font-size: ${props => props.theme.font.size.lg};
    }
  }
`

const BottomText = styled.div`
  color: white;
  position: relative;
  z-index: 10;
`

const thumbSlidersettings = {
  dots: false,
  infinite: false,
  slidesToShow: 7,
  slidesToScroll: 1,
  lazyload: false,
  prevArrow: <PrevButton desktopHidden={true} />,
  nextArrow: <NextButton desktopHidden={true} />,
  // variableWidth: true,
  focusOnSelect: true,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    }
  ]
}

function PrevButton({onClick}) {
  return <button onClick={onClick} className="solheim-arrow prev"><FontAwesomeIcon icon={faChevronLeft}/>
  </button>;
}

function NextButton({onClick}) {
  return <button onClick={onClick} className="solheim-arrow next"><FontAwesomeIcon icon={faChevronRight}/>
  </button>;
}

export default function PastChampions({block}) {
  const [activeYear, setActiveYear] = useState(0)

  const { backgroundImage, years } = block


  return(
    <Wrap className="position-relative overflow-hidden my-4">
      {backgroundImage && (
        <BgImage>
          <GatsbyImage 
            image={backgroundImage.localFile.childImageSharp.gatsbyImageData} 
            alt={backgroundImage.altText} 
          />
        </BgImage>
      )}
      <ContainerMax 
        maxWidth="1360"
        className="py-4"
      >
        <Row>
          <Col xs={12} md={{ order: 2 }}>
            {/* nav */}
            <Nav>
              <Slider
                {...thumbSlidersettings}
                className="w-100"
              >
                {years?.map((year, i) => {
                  return(
                    <div className="slide">
                      <YearBtn
                        key={`yearBtn${i}`}
                        onClick={() => setActiveYear(i)}
                        active={i === activeYear}
                      >{year.year}</YearBtn>
                    </div>
                  )
                })}
              </Slider>
            </Nav>
          </Col>
          <Col xs={12} md={{ order: 1 }}>
            {/* title */}
            {years?.map((year, i) => {
              return(
                <h3
                  className={classNames({
                    "d-block": i === activeYear,
                    "d-none": i !== activeYear
                  })}
                  key={`yeartitle${i}`}
                >
                  {year.year}
                </h3>
              )
            })}
          </Col>
        </Row>

        {/* players */}
        {years?.map((year, i) => {
          return(
            <div 
              className={classNames({
                "d-block": i === activeYear,
                "d-none": i !== activeYear
              })}
              key={`yearPlayers${i}`}
            >
              <Row>
                {year.players?.map((player, i) => {
                  return(
                    <Player>
                      <div className="content">
                        {player.image && (
                          <GatsbyImage image={player.image.localFile.childImageSharp.gatsbyImageData} alt={player.image.altText} />
                        )}
                        <div className="player">{player.name}</div>
                        <div className="year">{player.yearWon}</div>
                      </div>
                    </Player>
                  )
                })}
              </Row>
              {year.bottomText && (
                <BottomText dangerouslySetInnerHTML={{ __html: year.bottomText }} />
              )}
            </div>
          )
        })}
      </ContainerMax>
    </Wrap>
  )
}